import './styles.css';
import { getCognitoConfig, getConfigOverride, resolveWithOverride } from '@packages/shared';
import { Amplify } from 'aws-amplify';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppRouter } from '@/AppRouter';
import { AuthProviders } from '@/auth/AuthProviders';
import { TooltipProvider } from '@/components/ui/tooltip';
import { ThemeProvider } from '@/components/ui+/ThemeProvider';

const cognitoConfig = getCognitoConfig();
Amplify.configure(cognitoConfig);

// Set the page <title>, based on STAGE.
const stage = import.meta.env.VITE_STAGE;
document.title = stage === 'production' ? 'Admin' : `Admin *${stage}`;

// Setup PostHog
posthog.init('phc_RnGTMHBHcwmK4F9O3XV2Bibtc2xUelnsLWDi6ICEq8s', {
  api_host: 'https://us.i.posthog.com',
  defaults: '2025-05-24',
});

// biome-ignore lint/style/noNonNullAssertion: root needs to exist for app to render
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PostHogProvider client={posthog}>
      <AuthProviders
        convexUrl={resolveWithOverride(
          import.meta.env.VITE_CONVEX_URL,
          getConfigOverride()?.convexUrl,
        )}
      >
        <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
          {/* https://www.radix-ui.com/primitives/docs/components/tooltip#api-reference */}
          <TooltipProvider delayDuration={150}>
            <AppRouter />
          </TooltipProvider>
        </ThemeProvider>
      </AuthProviders>
    </PostHogProvider>
  </StrictMode>,
);
